import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App';
import router from './router';
import store from './vuex';
import 'signalr' // 消息盒子

// 第三方库
import './plugins/vendor'

// 全局组件
import './plugins/components'

// 全局对象
import './plugins/global'

// 自定义指令
import './plugins/directives'

// sentry
// import './plugins/sentry'

// 埋点
// import './plugins/sensor/index'

// filter
import * as filters from './filter'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

// Element、多语言
import Element from 'element-ui'  // 还需引入css，已引到style/index.sass里
import i18n from '@/assets/i18n'
Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value)
})

// vue config
Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
